import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/newAppointmentTypes';

export const setAppointmentForm = (appointmentFormVal: { [x: string]: any }): Action<any> => ({
  type: actionTypes.SET_APPOINTMENT_FORM_VAL, ...{ appointmentFormVal },
}
);

export const setSelectedCategory = (option: any): Action<any> => {
  return updateAction(actionTypes.SET_OPTION, option);
};

export const getSubCategories = (payload: any): Action<any> => {
  return updateAction(actionTypes.GET_SUB_CATEGORIES, payload);
};

export const subCategoriesData = (payload: any): Action<any> => {
  return updateAction(actionTypes.SUB_CATEGORIES_DATA, payload);
};

export const setSelectedSubCategory = (option: any): Action<any> => {
  return updateAction(actionTypes.SET_SUB_CATEGORY_OPTION, option);
};

export const getTimeSlot = (payload: any): Action<any> => {
  return updateAction(actionTypes.GET_TIME_SLOTS, payload);
};

export const setTimeSlots = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_TIME_SLOTS, payload);
};

export const setAppointmentDate = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_APPOINTMENT_DATE, payload);
};

export const submitForm = (payload: any): Action<any> => {
  return updateAction(actionTypes.SUBMIT_FORM, payload);
};
